export default {
  // apiServerUrl: 'https://dev.bookero.pl',
  apiServerUrl: 'https://internal.bookero.pl',
  // apiServerUrl: 'http://bookero-web.localhost:8888',
  // pluginServerUrl: 'https://dev.bookero.pl',
  pluginServerUrl: 'https://cdn.bookero.pl',
  // pluginServerUrl: 'http://bookero-web.localhost:8888',
  registrationEnabled: true,
  notificationsEnabled: true,
  isBeta: false,
  uiLanguage: 'pl',
  fbIntegrationEnabled: true,
  ga4Enabled: true,
  appVersion: '1.3'
}



// WEBPACK FOOTER //
// ./src/env.js